var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"login-container"},[_c('div',{staticClass:"notif-wrapper"},[_c('div',{staticClass:"notif-text"},[_vm._v(" "+_vm._s(_vm.$store.state.notifText)+" ")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }